import RPMPatientHistory from './patient-history';
import './patient-history.css';

export default RPMPatientHistory;
